Directives.OpenQuestionDirective = function OpenQuestionDirective() {

    //@ngInject
    function OpenQuestionDirectiveControllerFunc($scope, $injector) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'OpenQuestionDirectiveController';

        this.inputFocused = function inputFocused() {
            this.focusedOnId = this.question._id;
        };

        this.updateQuestion = function updateQuestion() {
            // we want to reset the focus id, in case he clicks outside.
            this.focusedOnId = "";
            this._updateQuestion();
        };
    }

    var OpenQuestionDirectiveController = Class(Controllers.BaseController, {
        constructor: OpenQuestionDirectiveControllerFunc
    });

    return {
        restrict: 'E',
        scope: {
            question: '=question',
            _updateQuestion: '&updateQuestion',
            isAnswerEditable: '&isAnswerEditable',
            isQuestionEditable: '&isQuestionEditable',
            focusedOnId: '=focusedOnId',
            isEditMode: '=isEditMode'
        },
        templateUrl : 'angular/app/modules/common/ui_components/questions/open_question/open_question_directive_template.html',
        controller: OpenQuestionDirectiveController,
        controllerAs: 'questionVm',
        bindToController: true
    };
};